import React from 'react';
import { useTranslation } from 'react-i18next';
import AmericanExpress from '../../../../images/svgs/american-express.svg';
import DinersWhite from '../../../../images/svgs/diners-white.svg';
import Elo from '../../../../images/svgs/elo.svg';
import Master from '../../../../images/svgs/master.svg';
import VisaWhite from '../../../../images/svgs/visa-white.svg';
import BarcodeWhite from '../../../../images/svgs/barcode-white.svg';
import Pix from '../../../../images/svgs/pix_footer.svg';
import styles from './FooterPayments.module.css';

const METHODS = [
  { src: AmericanExpress, altKey: 'AMERICAN_EXPRESS' },
  { src: DinersWhite, altKey: 'DINERS' },
  { src: Elo, altKey: 'ELO' },
  { src: Master, altKey: 'MASTERCARD' },
  { src: VisaWhite, altKey: 'VISA' },
  { src: BarcodeWhite, altKey: 'BOLETO_BANCARIO' },
  { src: Pix, altKey: 'PIX' }
];

export default function FooterPayments() {
  const { t } = useTranslation('footer');
  return (
    <div className={styles.root}>
      <div className={styles.title}>{t('PAYMENT_TYPES')}</div>
      <div className={styles.icons}>
        {METHODS.map(({ src, altKey }) => (
          <img key={altKey} src={src} alt={t(altKey)} className={styles.icon} />
        ))}
      </div>
    </div>
  );
}
